import React from "react";
import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material";

const Card33VideoHorizontal= ({ card }) => (
  <Box sx={{ marginBottom: 4 }}>
      {card.cardMetaData?.title && (
        <Typography variant="h6" sx={{ marginBottom: 2 }}>
          {card.cardMetaData.title}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: 2, overflowX: "auto" }}>
        {card.cardData.map((item, idx) => (
          <Card key={idx} sx={{ minWidth: 240, position: "relative" }}>
            <CardMedia
              component="img"
              image={item.data.thumbnail}
              alt={item.data.title}
              sx={{ height: 140 }}
            />
            <CardContent>
              <Typography variant="body1" fontWeight="bold">
                {item.data.title}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {item.data.description}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
);

export default Card33VideoHorizontal;